function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import SearchBar from '@components/util/SearchBar';
import React, { useEffect, useState } from 'react';
import { Card, Col, Pagination, Row } from 'react-bootstrap';
import { Table } from '@rd-web-markets/shared/dist/util';
import { useTranslation } from 'react-i18next';
import { DeleteButton, EditButton } from '../../util/buttons';
import { useDispatch } from 'react-redux';
import { handleError } from '../../store/features/alertSlice';
import businessUnitsService from '../../services/business_unit.service';
import BusinessUnitEditForm from './BusinessUnitEditForm';
import * as QueryString from 'query-string';
import { useHistory } from 'react-router-dom';
const initialParams = 'page=1&query=&order_by=name asc';
const BusinessUnitsList = _ref => {
  var _params$order_by, _params$order_by2;
  let {
    company,
    setCompany,
    loading,
    setLoading,
    handleToaster,
    refreshFlag
  } = _ref;
  const {
    t
  } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const [isEditing, setIsEditing] = useState(false);
  const [index, setIndex] = useState(null);
  const [bussinessUnitToEdit, setBusinessUnitToEdit] = useState({});
  const [bussinessUnits, setBussinesUnits] = useState([]);
  const [totalPages, setTotalPages] = useState(null);
  const [params, setParams] = useState(QueryString.parse(window.location.search || initialParams));
  useEffect(() => {
    const fetchBusinessUnits = async () => {
      setLoading(true);
      const response = await businessUnitsService.all(company.id, QueryString.stringify(params));
      setBussinesUnits(response.business_units || []);
      setTotalPages(response.pages);
      history.push({
        search: QueryString.stringify(params)
      });
      setLoading(false);
    };
    fetchBusinessUnits();
  }, [company.id, params, dispatch, history, setLoading, refreshFlag]);
  const deleteBu = async bu => {
    if (bu.project_business_units.length > 0) {
      handleToaster("You are trying to delete a Business Unit that has been assigned to a Project, please unassigned it from the Project to delete, otherwise set this Business Unit to 'Not Active' - thanks", 'warning');
    } else {
      if (window.confirm('Are you sure ?')) {
        try {
          setLoading(true);
          await businessUnitsService.delete(company.id, bu.id);
          const response = await businessUnitsService.all(company.id, QueryString.stringify(params));
          setBussinesUnits(response.business_units || []);
          setTotalPages(response.pages);
        } catch (e) {
          dispatch(handleError(e));
        } finally {
          setLoading(false);
        }
      }
    }
  };
  const handleSearch = query => {
    setParams(_objectSpread(_objectSpread({}, params), {}, {
      query,
      page: 1
    }));
  };
  const handleSearchReset = () => {
    setParams(_objectSpread(_objectSpread({}, params), {}, {
      query: '',
      page: 1
    }));
  };
  const handlePage = pageNumber => {
    setParams(_objectSpread(_objectSpread({}, params), {}, {
      page: pageNumber
    }));
  };
  const sortBusinessUnits = (eventKey, direction, headerText) => {
    const orderByMap = {
      [t('business_unit')]: 'name',
      [t('state')]: 'state'
    };
    const orderBy = orderByMap[headerText];
    if (orderBy) {
      setParams(_objectSpread(_objectSpread({}, params), {}, {
        order_by: "".concat(orderBy, " ").concat(direction)
      }));
    }
  };
  const headers = [_objectSpread({
    text: t('business_unit'),
    sortable: true
  }, ((_params$order_by = params.order_by) === null || _params$order_by === void 0 ? void 0 : _params$order_by.split(' ')[0]) === 'name' && {
    order: params.order_by.split(' ')[1]
  }), _objectSpread({
    text: t('state'),
    sortable: true
  }, ((_params$order_by2 = params.order_by) === null || _params$order_by2 === void 0 ? void 0 : _params$order_by2.split(' ')[0]) === 'state' && {
    order: params.order_by.split(' ')[1]
  }), {
    text: ''
  }];
  const handleEdit = (bu, index) => {
    setIsEditing(true);
    setBusinessUnitToEdit(bu);
    setIndex(index);
  };
  const handleEditComplete = async () => {
    setIsEditing(false);
    const response = await businessUnitsService.all(company.id, QueryString.stringify(params));
    setBussinesUnits(response.business_units || []);
    setTotalPages(response.pages);
  };
  const rows = bussinessUnits === null || bussinessUnits === void 0 ? void 0 : bussinessUnits.map((bu, index) => {
    return {
      key: bu.id,
      columns: [bu.name, bu.state === 'active' ? 'Active' : 'Not Active', /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(EditButton, {
        onClick: () => handleEdit(bu, index)
      }), /*#__PURE__*/React.createElement(DeleteButton, {
        onClick: () => deleteBu(bu)
      }))]
    };
  });
  const paginationItems = [];
  for (let number = 1; number <= totalPages; number++) {
    paginationItems.push(/*#__PURE__*/React.createElement(Pagination.Item, {
      key: number,
      active: number === parseInt(params.page || 1),
      onClick: () => handlePage(number)
    }, number));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Header, null, "Business Unit Listing"), /*#__PURE__*/React.createElement(Card.Body, null, !isEditing && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 4,
      offset: 8
    }
  }, /*#__PURE__*/React.createElement(SearchBar, {
    onSubmit: handleSearch,
    onSearchReset: handleSearchReset,
    loading: loading,
    query: params.query,
    placeholder: t('search_business_units')
  }))), /*#__PURE__*/React.createElement(Table, {
    headers: headers,
    rows: rows,
    onSort: (i, direction, headerText) => sortBusinessUnits(i, direction, headerText)
  })), isEditing && /*#__PURE__*/React.createElement(BusinessUnitEditForm, {
    setIsEditing: setIsEditing,
    bussinessUnitToEdit: bussinessUnitToEdit,
    setCompany: setCompany,
    company: company,
    loading: loading,
    setLoading: setLoading,
    index: index,
    onEditComplete: handleEditComplete
  }))), !isEditing && totalPages > 1 && /*#__PURE__*/React.createElement(Pagination, {
    className: "justify-content-end mt-3"
  }, paginationItems));
};
export default BusinessUnitsList;